import { render } from "./AvatarInput.vue?vue&type=template&id=7d6a3a13&scoped=true"
import script from "./AvatarInput.vue?vue&type=script&lang=js"
export * from "./AvatarInput.vue?vue&type=script&lang=js"

import "./AvatarInput.vue?vue&type=style&index=0&id=7d6a3a13&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6a3a13"]])

export default __exports__